import { render, staticRenderFns } from "./base-combobox.vue?vue&type=template&id=778e856f&scoped=true&"
import script from "./base-combobox.vue?vue&type=script&lang=js&"
export * from "./base-combobox.vue?vue&type=script&lang=js&"
import style0 from "./base-combobox.vue?vue&type=style&index=0&id=778e856f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778e856f",
  null
  
)

export default component.exports